import { render, staticRenderFns } from "./which-articles-to-alter.vue?vue&type=template&id=7959b7c4&scoped=true"
import script from "./which-articles-to-alter.vue?vue&type=script&lang=js"
export * from "./which-articles-to-alter.vue?vue&type=script&lang=js"
import style0 from "./which-articles-to-alter.vue?vue&type=style&index=0&id=7959b7c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7959b7c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7959b7c4')) {
      api.createRecord('7959b7c4', component.options)
    } else {
      api.reload('7959b7c4', component.options)
    }
    module.hot.accept("./which-articles-to-alter.vue?vue&type=template&id=7959b7c4&scoped=true", function () {
      api.rerender('7959b7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/which-articles-to-alter.vue"
export default component.exports